import React from "react";
import { Swiper } from "./MySwiperStyled";

export default function MySwiper({ p }) {
  return (
    <Swiper n={p.n}>
      {p.coeficients.coefs &&
        p.coeficients.coefs.map((el, indx) => (
          <Slide
            a={indx + 1 === 1 ? "1 HIT " : indx + 1 + " HITS"}
            b={el[indx + 1] + "x"}
            key={indx}
          />
        ))}
    </Swiper>
  );
}

const Slide = ({ a, b }) => {
  return (
    <div>
      {a} | {b}
    </div>
  );
};
